import React from 'react';

const Services = () => {
  return (
    <section className="section" id='services'>
    
    <div className="container mx-auto px-16">
      
    <div className='flex flex-col lg:flex-row justify-between'>
      <div className='flex flex-col'>
      <h2 className='h2 text-accent underline'>Education</h2>
      <ul className="flex flex-col space-y-2">
        <li className="flex items-start">
          <div className="w-2 h-2 bg-red-500 rounded-full mt-1"></div>
          <div className="ml-2 border-l border-red-500 pl-4">
          <div className="flex items-center mb-6">
        <div className="w-full">
          <h3 className="text-lg font-bold">Tezpur University</h3>
          <p className="text font-semibold">Bachelor of Technology in Computer Science & Engineering</p>
          <p className="text font-semibold">2021-25</p>
        </div>
      </div>
          </div>
        </li>
        <li className="flex items-start">
          <div className="w-2 h-2 bg-red-500 rounded-full mt-1"></div>
          <div className="ml-2 border-l border-red-500 pl-4">
          <div className="flex items-center mb-6">
        <div className="w-full">
          <h3 className="text-lg font-bold">Ranjit Sarma Academy Senior Secondery School</h3>
          <p className="text font-semibold">Class 12</p>
          <p className="text font-semibold">2019-21</p>
        </div>
      </div>
          </div>
        </li>
        <li className="flex items-start">
          <div className="w-2 h-2 bg-red-500 rounded-full mt-1"></div>
          <div className="ml-2 border-l border-red-500 pl-4">
          <div className="flex items-center mb-6">
        <div className="w-full">
          <h3 className="text-lg font-bold">Sankardev sishu vidya niketan, mangaldai</h3>
          <p className="text font-semibold">Class 10 </p>
          <p className="text font-semibold">2018-19</p>
        </div>
      </div>
          </div>
        </li>
      </ul>

     
      </div>
      <div className='flex flex-col'>
      <h2 className='h2 text-accent underline'>Experience</h2>
      <ul className="flex flex-col space-y-2">
      <li className="flex items-start">
          <div className="w-2 h-2 bg-red-500 rounded-full mt-1"></div>
          <div className="ml-2 border-l border-red-500 pl-4">
          <div className="flex items-center mb-6">
        <div className="w-full">
          <h3 className="text-lg font-bold">XopunTech(India) pvt Limited</h3>
          <p className="text font-semibold">Software developer Intern</p>
          <p className="text font-semibold">June 2024 - july 2024</p>
        </div>
      </div>
          </div>
        </li>
        <li className="flex items-start">
          <div className="w-2 h-2 bg-red-500 rounded-full mt-1"></div>
          <div className="ml-2 border-l border-red-500 pl-4">
          <div className="flex items-center mb-6">
        <div className="w-full">
          <h3 className="text-lg font-bold">VrixaaLabs</h3>
          <p className="text font-semibold">React developer Intern</p>
          <p className="text font-semibold">January 2024 - August 2024</p>
        </div>
      </div>
          </div>
        </li>
        <li className="flex items-start">
          <div className="w-2 h-2 bg-red-500 rounded-full mt-1"></div>
          <div className="ml-2 border-l border-red-500 pl-4">
          <div className="flex items-center mb-6">
        <div className="w-full">
          <h3 className="text-lg font-bold">Navalogy Club</h3>
          <p className="text font-semibold">Frontend developer Intern</p>
          <p className="text font-semibold">Dec 2023- Ongoing</p>
          <p className="text font-semibold">As part of navalogy club development team till now i had worked on developed the IEEE (Tezpur University Chepter) official website frontend layout using React js
          <br />Apart from this i am currently working on a Ecommerce website development for the frontend Part</p>


        </div>
      </div>
          </div>
        </li>
        <li className="flex items-start">
          <div className="w-2 h-2 bg-red-500 rounded-full mt-1"></div>
          <div className="ml-2 border-l border-red-500 pl-4">
          <div className="flex items-center mb-6">
        <div className="w-full">
          <h3 className="text-lg font-bold">Aikdhi India</h3>
          <p className="text font-semibold">Frontend Developer Intern</p>
          <p className="text font-semibold">Aug 2023-Sept 2023</p>
          <p className='text font-semibold'>Skill:HTML,CSS,JAVASCRIPT,BOOTSTRAP,REACT JS,SWIPPER JS</p>
          <p className='text font-semibold'>I was part of the Development team of Aikdhi official website development.My role was to develop and design the frontend of thier website</p>

          
        </div>
      </div>
          </div>
        </li>
      </ul>

     
      </div>
      </div>
    </div>
  </section>);
};

export default Services;
